import { createFileRoute } from '@tanstack/react-router';

import { requirePermission } from '@/app/guards';
import { NewDraftOrderPage } from '@/features/draft-orders';

export const Route = createFileRoute('/_authed/_active/s/$storeId/draft-orders/new')({
  staticData: { crumb: 'draftOrders:new' },
  beforeLoad: ({ context }) => {
    requirePermission(context.me, 'orders.write');
  },
  component: NewDraftOrderPage,
});
